import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorBotChart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M12.6 5.152a1.75 1.75 0 1 0-1 0V7.25h-5A3.75 3.75 0 0 0 2.85 11v2.045a1.973 1.973 0 0 0 0 3.854V19a3.75 3.75 0 0 0 3.75 3.75h11A3.75 3.75 0 0 0 21.35 19v-2.026a1.972 1.972 0 0 0 0-3.892V11a3.75 3.75 0 0 0-3.75-3.75h-5V5.152Zm5 16.098h-11A2.25 2.25 0 0 1 4.35 19v-8A2.25 2.25 0 0 1 6.6 8.75h11A2.25 2.25 0 0 1 19.85 11v8a2.25 2.25 0 0 1-2.25 2.25Z"
    />
    <path
      fill="#F7A600"
      d="M18.53 11.47a.75.75 0 0 1 0 1.06l-3.927 3.927a.75.75 0 0 1-1.01.046l-2.84-2.366L7.03 17.86a.75.75 0 1 1-1.06-1.061l4.207-4.207a.75.75 0 0 1 1.01-.046l2.84 2.366 3.443-3.442a.75.75 0 0 1 1.06 0ZM18.17 3.2l.073.44a3.348 3.348 0 0 0 2.646 2.732 3.348 3.348 0 0 0-2.646 2.732l-.073.44-.07-.42a3.38 3.38 0 0 0-2.649-2.752 3.348 3.348 0 0 0 2.646-2.732l.073-.44Z"
    />
  </svg>
);
export default SvgTwoColorBotChart;
